export default "__VITE_ASSET__Bcfio0Rj__"